import * as types from '../types/authType';
import { setResetLoading } from '../../../../redux/loading/actions/loadingAction';

/**
 *
 * @description Set reset global state
 * @return dispatch
 *
 */
export const setReset = () => (
	async (dispatch) => {
		dispatch( setIsLoadingForm(false) );
		dispatch( setIsAuthenticated(false) );
		dispatch( setTokenType('') );
		dispatch( setAccessToken('') );
		dispatch( setExpiresAt('') );
		dispatch( setResetLoading() );
	}
);

/**
 *
 * @description Set loadingForm state
 * @param value
 * @return object
 *
 */
export const setIsLoadingForm = value => ({
	type: types.IS_LOADING_FORM_AUTH,
	payload: value
});

/**
 *
 * @description Set authenticated state
 * @param value
 * @return object
 *
 */
export const setIsAuthenticated = value => ({
	type: types.IS_AUTHENTICATED,
	payload: value
});

/**
 *
 * @description Set tokenType state
 * @param value
 * @return object
 *
 */
export const setTokenType = value => ({
	type: types.TOKEN_TYPE,
	payload: value
});

/**
 *
 * @description Set accessToken state
 * @param value
 * @return object
 *
 */
export const setAccessToken = value => ({
	type: types.ACCESS_TOKEN,
	payload: value
});

/**
 *
 * @description Set expiresAt state
 * @param value
 * @return object
 *
 */
export const setExpiresAt = value => ({
	type: types.EXPIRES_AT,
	payload: value
});
